import {RouteNode}             from "../routes";
import {ProgramDefaultsRoutes} from "./program-defaults/program-defaults-routes-object";

import {
    AGENT_LEVEL, BRANCH_LEVEL, COMPANY_LEVEL
} from "../common/logic/user-level";

export const AccountRoutesObject: Record<string, RouteNode> = {
    account: {
        path: "/account",
        component: "AccountRerouter",
        children: {
            "address-book": {
                path: "/address-book",
                component: "AccountAddressBookRerouter",
                children: {
                    "address-lists": {
                        path: "/address-lists",
                        component: "MailingRoute",
                        userLevels: [AGENT_LEVEL],
                    },
                    "mailing-assets": {
                        path: "/mailing-assets",
                        component: "MailingAssetsRoute",
                        userLevels: [AGENT_LEVEL],
                    },
                    shipping: {
                        path: "/shipping",
                        component: "ShippingAddressesRoute",
                        userLevels: [AGENT_LEVEL],
                    },
                },
            },
            admin: {
                path: "/admin",
                redirect: "/user",
                userLevels: [BRANCH_LEVEL, COMPANY_LEVEL],
                children: {
                    accounting: {
                        path: "/accounting",
                        component: "AccountingRerouter",
                        userLevels: [BRANCH_LEVEL, COMPANY_LEVEL],
                        children: {
                            "ad-budgets": {
                                path: "/ad-budgets",
                                component: "AccountAdminAdBudgetsRoute",
                                userLevels: [BRANCH_LEVEL, COMPANY_LEVEL],
                            },
                            "ad-budget-defaults": {
                                path: "/ad-budget-defaults",
                                component: "AccountAdminAdBudgetDefaultsRoute",
                                userLevels: [COMPANY_LEVEL],
                            },
                            "vouchers": {
                                path: "/vouchers",
                                component: "AccountAdminVouchersRoute",
                                userLevels: [BRANCH_LEVEL, COMPANY_LEVEL],
                            },
                        },
                    },
                    "listing-form": {
                        path: "/listing-form",
                        component: "AccountAdminListingsFormRoute",
                        userLevels: [BRANCH_LEVEL, COMPANY_LEVEL],
                    },
                    "listing-recipient-admin": {
                        path: "/listing-recipient-admin",
                        component: "AccountAdminListingsRoute",
                        userLevels: [BRANCH_LEVEL, COMPANY_LEVEL],
                    },
                    office: {
                        path: "/office",
                        component: "AccountOfficeManagementRoute",
                        userLevels: [COMPANY_LEVEL],
                        children: {
                            "address-lists": {
                                path: "/address-lists",
                                component: "OfficeAddressListsRoute",
                                userLevels: [COMPANY_LEVEL],
                            },
                            "mailing-assets": {
                                path: "/mailing-assets",
                                component: "OfficeMailingAssetsRoute",
                                userLevels: [COMPANY_LEVEL],
                            },
                        },
                    },
                    reports: {
                        path: "/reports",
                        redirect: "/transaction",
                        userLevels: [BRANCH_LEVEL, COMPANY_LEVEL],
                        children: {
                            "activity-dashboard": {
                                path: "/activity-dashboard",
                                component: "AccountActivityDashboardRoute",
                                userLevels: [BRANCH_LEVEL, COMPANY_LEVEL],
                            },
                            transaction: {
                                path: "/transaction",
                                component: "AccountTransactionRoute",
                                userLevels: [BRANCH_LEVEL, COMPANY_LEVEL],
                            },
                        },
                    },
                    user: {
                        path: "/user",
                        component: "AccountUserManagementRoute",
                        userLevels: [BRANCH_LEVEL, COMPANY_LEVEL],
                        children: {
                            "address-lists": {
                                path: "/address-lists",
                                component: "AccountAdminAddressListsRoute",
                                userLevels: [BRANCH_LEVEL, COMPANY_LEVEL],
                            },
                            "credit-cards": {
                                path: "/credit-cards",
                                component: "AccountAdminCreditCardsRoute",
                                userLevels: [BRANCH_LEVEL, COMPANY_LEVEL],
                            },
                            headshots: {
                                path: "/headshots",
                                component: "AccountAdminHeadshotsRoute",
                                userLevels: [BRANCH_LEVEL, COMPANY_LEVEL],
                            },
                            logos: {
                                path: "/logos",
                                component: "AccountAdminLogosRoute",
                                userLevels: [BRANCH_LEVEL, COMPANY_LEVEL],
                            },
                            "mailing-assets": {
                                path: "/mailing-assets",
                                component: "AccountAdminMailingAssetsRoute",
                                userLevels: [BRANCH_LEVEL, COMPANY_LEVEL],
                            },
                            "scheduled-campaigns": {
                                path: "/scheduled-campaigns",
                                component: "AccountAdminScheduledCampaignsRoute",
                                userLevels: [BRANCH_LEVEL, COMPANY_LEVEL],
                                children: {
                                    ":step": {
                                        path: "/:step",
                                        component: "AccountAdminScheduledCampaignsRoute",
                                        userLevels: [BRANCH_LEVEL, COMPANY_LEVEL],
                                    },
                                },
                            },
                            shipping: {
                                path: "/shipping",
                                component: "AccountAdminShippingRoute",
                                userLevels: [BRANCH_LEVEL, COMPANY_LEVEL],
                            },
                            social: {
                                path: "/social",
                                component: "AccountAdminSocialRoute",
                                userLevels: [BRANCH_LEVEL, COMPANY_LEVEL],
                            },
                        },
                    },
                    "user-assets": {
                        path: "/user-assets",
                        component: "UserAssetsRedirectRoute",
                        userLevels: [BRANCH_LEVEL, COMPANY_LEVEL],
                    },
                },
            },
            analytics: {
                path: "/analytics",
                component: "AnalyticsRoute",
                userLevels: [AGENT_LEVEL, BRANCH_LEVEL, COMPANY_LEVEL],
            },
            company: {
                path: "/company",
                redirect: "/company-info",
                userLevels: [COMPANY_LEVEL],
                children: {
                    "company-info": {
                        path: "/company-info",
                        component: "AccountCompanyInfoRoute",
                        userLevels: [COMPANY_LEVEL],
                    },
                    "address-book": {
                        path: "/address-book",
                        component: "AccountCompanyAddressBookRoute",
                        userLevels: [COMPANY_LEVEL],
                    },
                },
            },
            "my-profile": {
                path: "/my-profile",
                component: "AccountMyProfileRoute",
                userLevels: [BRANCH_LEVEL, COMPANY_LEVEL],
            },
            office: {
                path: "/office",
                redirect: "/office-info",
                userLevels: [BRANCH_LEVEL],
                children: {
                    "office-info": {
                        path: "/office-info",
                        component: "AccountOfficeInfoRoute",
                        userLevels: [BRANCH_LEVEL],
                    },
                    "address-book": {
                        path: "/address-book",
                        component: "AccountAddressBookRoute",
                        userLevels: [BRANCH_LEVEL],
                    },
                },
            },
            orders: {
                path: "/orders",
                component: "AccountOrdersRerouter",
                children: {
                    approval: {
                        path: "/approval",
                        component: "AccountApprovalRoute",
                        userLevels: [BRANCH_LEVEL, COMPANY_LEVEL],
                    },
                    history: {
                        path: "/history",
                        component: "AccountHistoryRoute",
                    },
                    pending: {
                        path: "/pending",
                        component: "AccountPendingRoute",
                    },
                    scheduled: {
                        path: "/scheduled",
                        component: "AccountScheduledRoute",
                    },
                },
            },
            password: {
                path: "/password",
                component: "PasswordRerouter",
            },
            profile: {
                path: "/profile",
                redirect: "/contact",
                userLevels: [AGENT_LEVEL],
                children: {
                    contact: {
                        path: "/contact",
                        component: "AccountContactRoute",
                        userLevels: [AGENT_LEVEL],
                    },
                    headshots: {
                        path: "/headshots",
                        component: "AccountHeadshotsRoute",
                        userLevels: [AGENT_LEVEL],
                    },
                    logos: {
                        path: "/logos",
                        component: "AccountLogosRoute",
                        userLevels: [AGENT_LEVEL],
                    },
                    security: {
                        path: "/security",
                        component: "AccountSecurityRoute",
                        userLevels: [AGENT_LEVEL],
                    },
                    social: {
                        path: "/social",
                        component: "AccountSocialRoute",
                        userLevels: [AGENT_LEVEL],
                    },
                    subscription: {
                        path: "/subscription",
                        component: "AccountSubscriptionRoute",
                        userLevels: [AGENT_LEVEL],
                    },
                },
            },
            wallet: {
                path: "/wallet",
                redirect: "/credit-cards",
                userLevels: [AGENT_LEVEL],
                children: {
                    "ad-budget": {
                        path: "/ad-budget",
                        component: "AccountAdBudgetRoute",
                        userLevels: [AGENT_LEVEL],
                    },
                    "credit-cards": {
                        path: "/credit-cards",
                        component: "AccountCreditCardsRoute",
                        userLevels: [AGENT_LEVEL],
                    },
                    vouchers: {
                        path: "/vouchers",
                        component: "AccountVouchersRoute",
                        userLevels: [AGENT_LEVEL],
                    },
                },
            },
            ...ProgramDefaultsRoutes,
        }
    }
};